import { render, staticRenderFns } from "./ListAnnouncements.vue?vue&type=template&id=70cf967a&"
import script from "./ListAnnouncements.vue?vue&type=script&lang=js&"
export * from "./ListAnnouncements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports